import { GetterTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";

const descriptionGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
    service: (state: IPropertyEditState) => state.service,
    listOfDescriptions: (state: IPropertyEditState) => {
        const descriptions = [...state.property.Descriptions || []];
        return descriptions;
    }
}

export default descriptionGetters;